/**
 * Determine which stream tab should be shown for the current time: the first
 * stream (in tab order) whose end time hasn't passed. The Slideshow
 * pseudo-stream ('TRIBUTE_VIDEO') is never auto-selected. After the final
 * stream has ended, fall back to the first tab — Memorial Moments (-1) when
 * the event has one, otherwise the first stream.
 * @param {Object[]} streams - streams from context, in tab order
 * @param {Boolean} hasMemorialMoments - whether the event has a Memorial Moments tab
 * @param {Date} now - current time (injectable for tests)
 * @return {Number} stream index to show (-1 for the Memorial Moments tab)
 */
const getActiveStreamIndex = (streams, hasMemorialMoments, now = new Date()) => {
    const index = streams.findIndex(stream => stream.id !== 'TRIBUTE_VIDEO' && now < new Date(stream.endTime));
    if (index !== -1) {
        return index;
    }
    // all streams have ended
    return hasMemorialMoments ? -1 : 0;
};

export default getActiveStreamIndex;
